















































































































































































































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import {
  emitFormChangeEvent,
  FormChangeEvent,
  FormFieldDefMap,
  makeValidatorDictionary,
} from '@/reusable/Form/formUtils';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import Confirmation from '@/components/Confirmation.vue';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import ConfirmacionEliminar from '@/reusable/Mantenedor/ConfirmacionEliminar.vue';
import { makeAccionesModal } from '@/reusable/Grid/aggridColumnDefUtils';
import { OperacionesCrud } from '../../../reusable/Mantenedor/mantenedorUtils';
import moment from 'moment';
import MantenedorGrid from '@/reusable/Grid/MantenedorGrid.vue';
import { fetchZonas } from '@/pantallas/Alertas/Services/fetchZonas';
import { Color, BaseRuta, TipoEventoCopiloto, Ruta } from './rutas';
import {
  GridApi,
  GridOptions,
  GridReadyEvent,
  ICellRendererParams,
  RowNode,
} from 'ag-grid-community';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import { actionsEvent } from '@/setup';
import NumericEditor from '@/reusable/Grid/Editors/NumericEditor.vue';

@Component({
  components: {
    FormFieldsContainer,
    Confirmation,
    ConfirmacionEliminar,
    MantenedorGrid,
  },
})
export default class CrearRutaFormEdit extends Vue {
  @Prop({ default: false }) isVerDetalle: boolean;
  @Prop({ default: false }) esEditar: boolean;
  @Prop({ default: (): [] => [] }) rutasDetalles: BaseRuta[];

  isFormValid: boolean = false;
  lsZonas: any[] = [];
  lsColor: Color[] = [];

  mostrarConfirmacionEliminar: boolean = false;
  mostrarDatos: boolean = false;
  mostrarModalCrear: boolean = false;
  mostrarModalEditar: boolean = false;

  hint: string = '';
  estado: boolean = true;
  seleccionEstado: number = 0;
  titulo: string = 'Crear Ruta';

  modalCrudActivo: OperacionesCrud = null;
  eventosCopiloto: TipoEventoCopiloto[] = [];

  /* misc */
  axiosCopiloto: AxiosVue = new AxiosVue(ServicioProxy.Copiloto);
  gridApi: GridApi = null;

  isValidateTP: boolean = false;
  isValidateRM: boolean = false;

  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();

  formFields: FormFieldDefMap = {
    estado: {
      label: 'Estado',
      id: 'id',
      value: '',
    },
    nombre: {
      label: 'Nombre',
      id: 'nombre',
      value: '',
    },
    zona: {
      label: 'Zonas',
      id: 'zona',
      value: '',
    },
    color: {
      label: 'Color',
      id: 'colorHexadecimal',
      value: '',
    },

    vminima: {
      label: 'Velocidad Mínima',
      id: 'vminima',
      value: '',
    },
    vmaxima: {
      label: 'Velocidad Máxima',
      id: 'vmaxima',
      value: '',
    },

    permiteDetencion: {
      label: 'Permite Detención',
      id: 'pdetencion',
      value: '',
    },
    tiempoPernencia: {
      label: 'Tiempo máximo de permanecia en la zona',
      id: 'tmin',
      value: '',
    },
    horaDesde: {
      label: 'Hora desde (HH:mm)',
      id: 'hdesde',
      value: '',
    },
    horaHasta: {
      label: 'Hora hasta (HH:mm)',
      id: 'hhasta',
      value: '',
    },
    RepetirMensaje: {
      label: 'Repetir Mensaje',
      id: 'rmensaje',
      value: '',
    },
    tiempoRepeticionMensaje: {
      label: 'Tiempo repetición mensaje',
      id: 'trepeticion',
      value: '',
    },
    tiempoEntrada: {
      label: 'Tiempo próximo entrar a zona',
      id: 'tiempoEntradaGeocerca',
      value: '',
    },
  };

  readonly gridOptions: GridOptions = {
    columnDefs: [
      {
        headerName: 'Nombre',
        field: 'nombre',
      },
      {
        headerName: 'Zona',
        field: 'zonaNombre',
      },
      {
        headerName: 'Velocidad máxima',
        cellEditorFramework: NumericEditor,
        field: 'vmax',
      },

      {
        headerName: 'Velocidad mínima',
        cellEditorFramework: NumericEditor,
        field: 'vmin',
      },
      {
        headerName: 'Permite detención',
        field: 'pdetenciontxt',
      },
      {
        headerName: 'Tiempo de permanecia',
        cellEditorFramework: NumericEditor,
        field: 'tmin',
      },
      {
        headerName: 'Hora desde (HH:mm)',
        field: 'hdesde',
      },
      {
        headerName: 'Hora hasta (HH:mm)',
        field: 'hhasta',
      },
      {
        headerName: 'Repetir mensaje',
        field: 'rmensajetxt',
      },
      {
        headerName: 'Tiempo repetición mensaje',
        cellEditorFramework: NumericEditor,
        field: 'trmensaje',
      },
      {
        headerName: 'Tiempo entrada a geocerca',
        cellEditorFramework: NumericEditor,
        field: 'tiempoEntradaGeocerca',
      },

      makeAccionesModal({
        onEliminar: this.handleEliminarClick,
      }),
    ].map(x => ({
      width: 130,
      hide: false,
      ...x,
    })),
    pagination: true,
    paginationPageSize: 5,
    onGridReady: this.handleGridReady,

    processCellForClipboard: ({ value }) => {
      return value instanceof moment
        ? this.formatFecha(value as moment.Moment)
        : value;
    },
  };

  async handleGridReady(event: GridReadyEvent) {
    this.gridApi = event.api;
    this.gridApi.setRowData(this.rutasDetalles || []);
  }

  mounted() {
    if (!this.isVerDetalle) {
      this.getZonas();
      this.setColor();
    }
  }

  created() {
    this.cambio();
    this.isValidateTP = false;
    this.isValidateRM = false;
    const validator = makeValidatorDictionary(this.formFields);
    this.$validator.localize('es', validator);
    if (this.isVerDetalle) {
      this.titulo = 'Ver detalle ruta';
    }
  }

  formatFecha(fecha: moment.Moment) {
    return fecha.format('DD/MM/YYYY');
  }

  handleEliminarClick(params: ICellRendererParams) {
    let deletedRow = params;

    this.gridApi.updateRowData({ remove: [deletedRow] }); // removeItems(row,false);
    this.gridApi.refreshCells();
    this.gridApi.redrawRows();
    let zonaIndex = this.rutasDetalles.indexOf(params.data);
    this.rutasDetalles.splice(zonaIndex, 1);

    this.modalCrudActivo = OperacionesCrud.eliminar;
  }

  handleCrearClick() {
    this.$validator.errors.clear();
    this.mostrarModalCrear = true;
  }
  handleCierraModalSinGuardar() {
    this.mostrarModalCrear = false;
    this.mostrarModalEditar = false;
  }

  async handleCierreModalBtnGuardar(e: FormChangeEvent) {
    this.mostrarModalCrear = false;
  }
  async handleCierreModalBtnGuardarEditar(e: FormChangeEvent) {}

  cerrarModalCrud() {
    this.modalCrudActivo = null;
  }

  constructor() {
    super();
    actionsEvent.onEliminar(this.handleEliminarClick);
  }

  cambio() {
    if (this.estado) {
      this.formFields.estado.value = 1;
      this.seleccionEstado = 1;
      this.formFields.estado.label = 'Activo';
      this.hint = '';
    } else {
      this.formFields.estado.value = 0;
      this.seleccionEstado = 2;
      this.formFields.estado.label = 'Inactivo';
      this.hint = 'Al dejar como inactivo, no se podrán realizar asociaciones.';
    }
    this.$emit('estadoSwitch', this.estado);
  }

  async getZonas() {
    this.lsZonas = (await this.fetchZonas()) || [];
  }

  fetchZonas() {
    this.loadingService.showLoading();
    return fetchZonas()
      .catch(error => {
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            this.$snotify.error('Ocurrió un error al obtener zonas.');
          }
        } else {
          this.$snotify.error('Ocurrió un error al obtener zonas.');
        }
      })
      .finally(() => {
        this.loadingService.hideLoading();
      });
  }

  setColor() {
    this.lsColor = [
      { color: 'Verde', colorhexadecimal: '#3ac873' },
      { color: 'Rojo', colorhexadecimal: '#ff0000' },
      { color: 'Amarillo', colorhexadecimal: '#f8ff00' },
    ];
  }

  async setForm(): Promise<void> {
    await this.valForm();

    let element = document.getElementById('txtNombre');
    element.setAttribute('disabled', 'disabled');

    if (this.$validator.errors.count() == 0) {
      let zonNombre = this.lsZonas.find(x => x.id == this.formFields.zona.value)
        .nombre;

      let idZona = Number(this.formFields.zona.value);

      this.eventosCopiloto = [
        { id: 1, idZona: idZona, nombre: 'Entrada', selected: false },
        {
          id: 2,
          idZona: idZona,
          nombre: 'Exceso de velocidad',
          selected: false,
        },
        {
          id: 3,
          idZona: idZona,
          nombre: 'Velocidad bajo la mínima',
          selected: false,
        },
        { id: 4, idZona: idZona, nombre: 'Detención', selected: false },
        { id: 5, idZona: idZona, nombre: 'Permanencia', selected: false },
        {
          id: 6,
          idZona: idZona,
          nombre: 'Restricción horaria',
          selected: false,
        },
        { id: 7, idZona: idZona, nombre: 'Salida', selected: false },
      ];

      this.rutasDetalles.filter(
        e => e.zona !== Number(this.formFields.zona.value)
      );

      // this.lsZonas = this.lsZonas.filter(
      //   (item) => item.id != this.formFields.zona.value
      // );

      this.rutasDetalles.push({
        nombre: this.formFields.nombre.value.toString(),
        zona: Number(this.formFields.zona.value),
        zonaNombre: zonNombre,
        colorHex: this.formFields.color.value.toString(),
        velocidadMinima: Number(this.formFields.vminima.value),
        velocidadMaxima: Number(this.formFields.vmaxima.value),
        pdetenciontxt:
          Boolean(this.formFields.permiteDetencion.value) == true ? 'Sí' : 'No',
        permitirDetencion: Boolean(this.formFields.permiteDetencion.value),
        rmensajetxt:
          Boolean(this.formFields.RepetirMensaje.value) == true ? 'Sí' : 'No',
        repetirMensaje: Boolean(this.formFields.RepetirMensaje.value),
        tiempoMaximo: Number(this.formFields.tiempoPernencia.value),
        tiempoRepetir: Number(this.formFields.tiempoRepeticionMensaje.value),
        horaDesde: this.formFields.horaDesde.value.toString(),
        horaHasta: this.formFields.horaHasta.value.toString(),
        tiempoEntradaGeocerca: Number(this.formFields.tiempoEntrada.value),
        lstTipoEventoCopiloto: this.eventosCopiloto,
        lstRutaEventoMensaje: null,
        id: 0,
        rutaId: 0,
        color: this.formFields.color.value.toString(),
        coordenadaId: Number(this.formFields.zona.value),
      });

      // this.lsZonas = this.lsZonas.filter(
      //   (item) => item.id != this.formFields.zona.value
      // );

      this.gridApi.setRowData(this.rutasDetalles || []);
    }
    this.$emit('changeDatosZonas', this.rutasDetalles);
  }

  async valForm() {
    if (this.formFields.permiteDetencion.value) {
      this.isValidateTP = true;
    } else {
      this.isValidateTP = false;
    }

    if (this.formFields.RepetirMensaje.value) {
      this.isValidateRM = true;
    } else {
      this.isValidateRM = false;
    }
  }
  cleanform() {
    this.formFields.zona.value = '';
  }

  @Watch('rutasDetalles')
  rutasDetallesChange() {
    if (this.esEditar) {
      this.gridApi.setRowData(this.rutasDetalles || []);

      this.titulo = 'Editar ruta';
      this.formFields.nombre.label = this.rutasDetalles[0].nombre;
      this.formFields.nombre.value = this.rutasDetalles[0].nombre;
    }
  }
}
